//TODO: PL - move the default name to salesforce-integration-subtypes like advance
export const DEFAULT_IMPORT_INTEGRATION_NAME = 'My Salesforce Import'
export const DEFAULT_PUBLISH_INTEGRATION_NAME = 'My Salesforce Publish Basic'

export const DEFAULT_INSTANCE_URL = 'https://login.salesforce.com'